import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Header } from "@/components/homepage/Header";
import { Footer } from "@/components/homepage/Footer";

export const Route = createFileRoute('/info')({
  component: MarketingLayout,
});

function MarketingLayout() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
